import React from 'react'
/* components */
import { Hidden } from '@mui/material'
import LogoMobile from '../LogoMobile/LogoMobile'

function ToggleMobile () {
  return (
    <Hidden mdUp>
      <LogoMobile />
    </Hidden>
  )
}

export default ToggleMobile
